import { GraduationCap, FileSpreadsheet, Sparkles, ShieldAlert } from "lucide-react";

export const TOOLS = [
  {
    id: "inkluzivko",
    name: "Inkluzivko",
    tagline: "Individualizirani kurikulum (IK)",
    description: "Individualizirani kurikulum i prilagodbe za učenike s teškoćama u razvoju",
    note: "Usklađeno sa Smjernicama za rad s učenicima s teškoćama (MZO) i Pravilnikom NN 24/15",
    noteUrl: "https://mzom.gov.hr/UserDocsImages/dokumenti/Obrazovanje/Smjernice%20za%20rad%20s%20ucenicima%20s%20teskocama.pdf",
    color: "#059669",
    colorLight: "#ECFDF5",
    colorBorder: "#A7F3D0",
    icon: GraduationCap,
    docTitle: "Individualizirani kurikulum",
    fields: [
      { name: "tip_programa", label: "Primjereni program obrazovanja", type: "select", options: ["Redoviti program uz individualizirane postupke", "Redoviti program uz prilagodbu sadržaja i individualizirane postupke", "Posebni program uz individualizirane postupke", "Posebni program za stjecanje kompetencija u aktivnostima svakodnevnoga života i rada"] },
      { name: "predmet", label: "Nastavni predmet", type: "select", options: ["Hrvatski jezik", "Matematika", "Engleski jezik", "Priroda i društvo", "Priroda", "Biologija", "Kemija", "Fizika", "Povijest", "Geografija", "Informatika", "Likovna kultura", "Glazbena kultura", "Tjelesna i zdravstvena kultura"] },
      { name: "razred", label: "Razred", type: "select", options: ["1. razred OŠ", "2. razred OŠ", "3. razred OŠ", "4. razred OŠ", "5. razred OŠ", "6. razred OŠ", "7. razred OŠ", "8. razred OŠ", "1. razred SŠ", "2. razred SŠ", "3. razred SŠ", "4. razred SŠ"] },
      { name: "dijagnoza", label: "Vrsta teškoće", type: "select", options: ["Oštećenje vida", "Oštećenje sluha", "Oštećenja jezično-govorne-glasovne komunikacije", "Specifične teškoće u učenju (disleksija, disgrafija, diskalkulija)", "Motorički poremećaji i kronične bolesti", "Intelektualne teškoće", "Deficit pažnje / hiperaktivni poremećaj (ADHD)", "Poremećaji u ponašanju i emocionalni poremećaji", "Poremećaj iz spektra autizma (PSA)", "Postojanje više vrsta teškoća (kombinirane)"] },
      { name: "ishodi", label: "Odgojno-obrazovni ishodi / tematske cjeline", type: "textarea", placeholder: "Unesite ishode iz kurikuluma ili tematske cjeline koje učenik treba savladati..." },
      { name: "zapazanja", label: "Inicijalna procjena / zapažanja o učeniku", type: "textarea", placeholder: "Pažnja, koncentracija, pamćenje, samostalnost, predznanja, interesi, jake strane...", optional: true },
    ],
    preset: {
      tip_programa: "Redoviti program uz prilagodbu sadržaja i individualizirane postupke",
      predmet: "Hrvatski jezik",
      razred: "5. razred OŠ",
      dijagnoza: "Specifične teškoće u učenju (disleksija, disgrafija, diskalkulija)",
      ishodi: "OŠ HJ A.5.1. Učenik govori i razgovara u skladu s temom; OŠ HJ A.5.4. Učenik čita tekst i prepričava sadržaj pripovijetke. Tematska cjelina: Pripovijetka - obilježja i analiza.",
      zapazanja: "Učenik sporije čita uz zamjene slova b/d, rukopis teže čitljiv, usmeno izražavanje uredno i bogato, dobro pamti slušane sadržaje, voli rad u paru, brzo se umara pri duljem pisanju.",
    },
  },
  {
    id: "misljenko",
    name: "Mišljenko",
    tagline: "Stručna mišljenja i izvješća",
    description: "Službena mišljenja i izvješća za vanjske ustanove i povjerenstva",
    color: "#4F46E5",
    colorLight: "#EEF2FF",
    colorBorder: "#C7D2FE",
    icon: FileSpreadsheet,
    docTitle: "Stručno mišljenje / izvješće",
    fields: [
      { name: "vrsta_dokumenta", label: "Vrsta dokumenta", type: "select", options: ["Stručno mišljenje za utvrđivanje psihofizičkog stanja", "Stručno mišljenje škole (opće)", "Izvješće o napretku učenika", "Preporuka za prilagodbu ispitne tehnologije (Državna matura)", "Izvješće za Hrvatski zavod za socijalni rad", "Izvješće za liječnika školske medicine"] },
      { name: "uloga", label: "Uloga stručnjaka", type: "select", options: ["Stručni suradnik psiholog", "Stručni suradnik pedagog", "Edukacijski rehabilitator", "Logoped", "Socijalni pedagog"] },
      { name: "natuknice", label: "Zapažanja i natuknice", type: "textarea", placeholder: "Unesite natuknice u slobodnom obliku: ponašanje na satu, ocjene, suradnja s roditeljima, jake strane, područja podrške..." },
    ],
    preset: {
      vrsta_dokumenta: "Izvješće za Hrvatski zavod za socijalni rad",
      uloga: "Stručni suradnik pedagog",
      natuknice: "Učenik 7. razreda, često izostaje s nastave (32 neopravdana sata), ocjene znatno pale u odnosu na prošlu godinu, majka se ne odaziva na pozive škole, zabilježeni sukobi s vršnjacima na odmorima, učenik je inteligentan i pokazuje interes za informatiku, otac ne živi s obitelji.",
    },
  },
  {
    id: "radioniko",
    name: "Aktivko",
    tagline: "Radionice i prevencija",
    description: "Kompletni scenariji radionica i preventivnih programa",
    color: "#D97706",
    colorLight: "#FFFBEB",
    colorBorder: "#FDE68A",
    icon: Sparkles,
    docTitle: "Radionica / preventivni program",
    fields: [
      { name: "tema", label: "Tema radionice", type: "input", placeholder: "npr. Vršnjačko nasilje, E-nasilje, Tehnike učenja, Emocionalna regulacija..." },
      { name: "dobna_skupina", label: "Ciljana skupina", type: "select", options: ["Učenici razredne nastave (1.-4. razred)", "Učenici predmetne nastave (5.-8. razred)", "Srednjoškolci", "Roditelji", "Učitelji i nastavnici (Stručno vijeće)"] },
      { name: "trajanje", label: "Trajanje", type: "select", options: ["45 minuta (1 školski sat)", "90 minuta (blok sat)", "Poludnevni program (3 sata)"] },
      { name: "ciljevi_ishodi", label: "Specifični ciljevi i napomene", type: "textarea", placeholder: "Navedite ciljeve ili specifičnosti razreda (npr. rad u grupama, interaktivne vježbe)...", optional: true },
    ],
    preset: {
      tema: "Prevencija vršnjačkog nasilja (cyberbullying)",
      dobna_skupina: "Učenici predmetne nastave (5.-8. razred)",
      trajanje: "45 minuta (1 školski sat)",
      ciljevi_ishodi: "Razred od 24 učenika, 6. razred. Nedavno je bilo slučajeva neprimjerenih poruka u razrednoj WhatsApp grupi. Cilj: prepoznavanje e-nasilja i strategije reagiranja.",
    },
  },
  {
    id: "zabiljesko",
    name: "Zabilješko",
    tagline: "Zapisnici i pedagoške mjere",
    description: "Službene zabilješke razgovora i obrazloženja pedagoških mjera",
    color: "#0891B2",
    colorLight: "#ECFEFF",
    colorBorder: "#A5F3FC",
    icon: ShieldAlert,
    docTitle: "Zabilješka / pedagoška mjera",
    fields: [
      { name: "vrsta_zapisa", label: "Vrsta zapisa", type: "select", options: ["Zabilješka o savjetodavnom razgovoru s učenikom", "Zapisnik sa sastanka s roditeljima / skrbnicima", "Obrazloženje pedagoške mjere - Opomena", "Obrazloženje pedagoške mjere - Ukor", "Obrazloženje pedagoške mjere - Strogi ukor", "Obrazloženje pedagoške mjere - Preseljenje u drugu školu", "Plan pojačanog odgojnog rada"] },
      { name: "cinjenice", label: "Činjenice i kronologija", type: "textarea", placeholder: "Opišite događaj ili povod razgovora, izjave sudionika, dogovorene zaključke, rokove i obveze..." },
    ],
    preset: {
      vrsta_zapisa: "Obrazloženje pedagoške mjere - Opomena",
      cinjenice: "Učenik 8. razreda tijekom velikog odmora 12.3. verbalno vrijeđao učenika 6. razreda, što su potvrdila dva svjedoka i dežurni učitelj. Ranije proveden savjetodavni razgovor s pedagogom (veljača) i obaviješteni roditelji. Učenik izrazio žaljenje. Prva pedagoška mjera.",
    },
  },
];
